/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowDIYProjectTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowDIYProject,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Build Something Awesome!",
    "DIY Project Awaits!",
    "Get Creative with Crafts!",
  ],
  title: "DIY Project",
  description: "Organize a fun DIY project day.",
  longDescription:
    "Gather your friends for a creative DIY project! Choose a date, decide on the project to work on, and plan activities for the day!",
  emoji: "🔨",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "DIY Project",
          emoji: "🔨",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the DIY project day?",
          emoji: "📅",
          completeAction: {
            question: "Decide on projects to undertake?",
            description: "What DIY projects should we focus on?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What projects should we consider?",
                emoji: "🛠",
                completeAction: {
                  question: "Decide on materials needed?",
                  description:
                    "What materials should we gather for our projects?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What materials should we bring?",
                      emoji: "📦",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Create Together!",
    outroDescription: "Your DIY project plans are set! Enjoy the creativity!",
  },
};
